<template>
  <el-dialog
    :title="title"
    :visible.sync="visible"
    width="840px"
    append-to-body
    :close-on-press-escape="false"
    :close-on-click-modal="false"
    @closed="handleClosed">
    <el-form
      ref="ruleForm"
      :validate-on-rule-change="false"
      :model="ruleForm"
      :rules="rules"
      label-width="100px">
      <el-form-item
        label="服务名称："
        prop="servName">
        <el-input
          v-model="ruleForm.servName"
          show-word-limit
          :maxlength="20"></el-input>
      </el-form-item>
      <el-form-item
        label="服务首图："
        prop="image">
        <upload-with-crop
          v-model="ruleForm.image"
          :cropper="true"
          :isLt2M="500"
          :limit="1"
          :fixedNumber="[5,3]"
          :autoCropWidth="120"
          :autoCropHeight="72"></upload-with-crop>
      </el-form-item>
      <el-form-item
        label="排序值："
        prop="sort">
        <el-input-number
          v-model="ruleForm.sort"
          :precision="0"
          :min="1"
          :max="1000"></el-input-number>
      </el-form-item>
      <el-form-item
        label="所属分类："
        prop="classId">
        <service-select v-model="ruleForm.classId" />
      </el-form-item>
      <el-form-item
        label="所属机构："
        prop="servOrgId">
        <service-org-select v-model="ruleForm.servOrgId" />
      </el-form-item>
      <el-form-item
        label="服务简介："
        prop="introduction">
        <el-input
          v-model="ruleForm.introduction"
          type="textarea"
          :autosize="{ minRows: 3, maxRows: 4}"
          show-word-limit
          :maxlength="150"></el-input>
      </el-form-item>
      <el-form-item
        label="服务详情："
        prop="contentImages">
        <desc-images
          v-model="ruleForm.contentImages"
          edit></desc-images>
      </el-form-item>
      <el-divider>扩展属性</el-divider>
      <template v-if="ruleForm.servAttrs.length > 0">
        <el-row
          v-for="(item, index) in ruleForm.servAttrs"
          :key="index">
          <el-col :span="11">
            <el-form-item
              label="标题："
              :prop="'servAttrs.' + index + '.key'"
              :rules="{ required: true, message: '标题不能为空', trigger: 'blur'}">
              <el-input v-model="item.key"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="11">
            <el-form-item
              label="内容："
              :prop="'servAttrs.' + index + '.value'"
              :rules="{ required: true, message: '内容不能为空', trigger: 'blur'}">
              <el-input v-model="item.value"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="2">
            <el-button
              :loading="loading"
              type="text"
              @click="deleteprop(index)">删除</el-button>
          </el-col>
        </el-row>
      </template>
      <el-empty
        v-else
        description="暂无扩展属性"></el-empty>
    </el-form>
    <span slot="footer">
      <el-button
        :loading="loading"
        type="primary"
        @click="addprop">添加扩展属性</el-button>
      <el-button
        :loading="loading"
        @click="visible = false">取 消</el-button>
      <el-button
        type="primary"
        :loading="loading"
        @click="handleSubmit">确 定</el-button>
    </span>
  </el-dialog>
</template>

<script>
import DescImages from '../../../components/public/desc-images.vue'
import UploadWithCrop from '../../../components/public/upload-with-crop.vue'
import ServiceOrgSelect from '../../../components/service-org-select.vue'
import ServiceSelect from '../../../components/service-select.vue'
import OrgService from '@/service/org-service'
export default {
  name: 'EditServModal',
  components: { DescImages, UploadWithCrop, ServiceSelect, ServiceOrgSelect },
  data() {
    return {
      loading: false,
      visible: false,
      ruleForm: { id: null, servOrgId: null, classId: null, servName: '', image: [], introduction: '', contentImages: [], servAttrs: [], sort: null },
      rules: {
        servName: [
          { required: true, message: '请输入服务名称', trigger: 'blur' }
        ],
        image: [
          { required: true, message: '请上传服务首图', trigger: 'change' }
        ],
        introduction: [
          { required: true, message: '请输入服务简介', trigger: 'blur' }
        ],
        contentImages: [
          { required: true, message: '请上传服务图片', trigger: 'change' }
        ],
        sort: [
          { required: true, message: '请输入排序数值', trigger: 'blur' }
        ],
        servOrgId: [
          { required: true, message: '请选择服务机构', trigger: 'blur' }
        ],
        classId: [
          { required: true, message: '请输入所属分类', trigger: 'blur' }
        ]
      }
    }
  },
  computed: {
    title({ ruleForm }) {
      return (ruleForm.id ? '编辑' : '新增') + '服务'
    }
  },
  methods: {
    addprop() {
      this.ruleForm.servAttrs.push({ key: '', value: '' })
    },
    deleteprop(index) {
      this.ruleForm.servAttrs.splice(index, 1)
    },
    handleClosed() {
      this.ruleForm = { ...this.ruleForm, ...this.$options.data().ruleForm }
    },
    handleSubmit() {
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          this.loading = true
          const { contentImages, image, servAttrs, id } = this.ruleForm
          const dispatch = id ? 'updateserv' : 'addserv'
          OrgService[dispatch]({
            ...this.ruleForm,
            image: this.$stringfyImage(image),
            contentImages: this.$stringfyImage(contentImages),
            servAttrs: JSON.stringify(servAttrs)
          })
            .then(res => {
              this.loading = false
              const { result, message } = res.data
              if (result === 0) {
                this.visible = false
                this.$message.success('提交成功')
                this.$emit('fetch')
              } else {
                this.$message.error(message)
              }
            })
            .catch(err => {
              this.loading = false
              this.$message.error(err.message)
            })
        }
      })
    },
    init(options = {}) {
      const { contentImages, image, servAttrs } = options
      this.ruleForm = {
        ...this.ruleForm,
        ...options,
        servAttrs: servAttrs ? JSON.parse(servAttrs) : [],
        contentImages: this.$splitImage(contentImages),
        image: this.$splitImage(image)
      }
      this.visible = true
    }
  }
}
</script>
